var fn_print = function () {

    $('.js-print').click(function(e){
        e.preventDefault();
        window.print();
    });

};
